import React from 'react';
import { GenericFilterHeader } from './GenericFilterHeader';
import { AUTO_DECLINED_STATUS_FILTER } from '../../requestsTableRenderers';

const STATUS_OPTIONS = [
    'All',
    'New Request',
    'Interim Price',
    'Pending',
    'Approved',
    'Declined',
    AUTO_DECLINED_STATUS_FILTER,
    'Urgent',
];

interface StatusColumnHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function StatusHeader({
    currentValue,
    onChange,
}: StatusColumnHeaderProps) {
    return (
        <GenericFilterHeader
            label="Status"
            filterOptions={STATUS_OPTIONS}
            currentValue={currentValue}
            onChange={onChange}
        />
    );
}

StatusHeader.displayName = 'StatusHeader';
